export function initialize(appInstance) {
  appInstance.lookup("service:analytics")
}

export default {
  name: "analytics",
  initialize: initialize,
}
